module.exports = __webpack_public_path__ + "static/media/mahzooz.d1206f6a.png";